import { Mark } from 'slate'
import { BOLD_MARK } from './markTypes'

export default function BoldMark() {
  return Mark.create({
    type: BOLD_MARK
  })
}
